<template>
    <v-row align="center" class="grey lighten-5 mx-auto partner-list-section">
        <div class="d-flex flex-wrap" v-if="filteredPartners.length">
            <div
                class="partners-section"
                v-for="(partner, i) in filteredPartners"
                :key="i"
            >
                <v-card
                    class="d-flex align-center partner-card"
                    hover
                    :href="`${partner.link}`"
                    target="_blank"
                    :height="$vuetify.breakpoint.smAndUp ? 230 : 186"
                    :width="$vuetify.breakpoint.smAndUp ? 372 : 300"
                    :ripple="false"
                    :data-ga="`Game Card|${partner.name}`"
                >
                    <img
                        v-if="isEdgeBrowser"
                        :src="`${baseURL}${partner.imageUrl}`"
                        alt="partners"
                    />
                    <v-img
                        v-else
                        :src="`${baseURL}${partner.imageUrl}`"
                        contain
                    >
                        <template v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                                <v-progress-circular
                                    indeterminate
                                    color="#2960e8"
                                ></v-progress-circular>
                            </v-row>
                        </template>
                    </v-img>
                </v-card>
                <p class="partner-name">{{ partner.name }}</p>
                <p class="partner-publisher">{{ partner.publisher }}</p>
            </div>
        </div>
        <div v-else class="no-results-section">
            <div class="no-results-group">
                <v-img
                    width="203px"
                    height="113px"
                    contain
                    class="no-result-image"
                    :src="require('@/assets/no-search-results.png')"
                ></v-img>
                <span
                    >Your search word did not match any games. <br />
                    Please retry.</span
                >
            </div>
        </div>
    </v-row>
</template>

<script>
import { getUmbracoEnv } from '@/config/umbraco-env';

export default {
    name: 'partners-list',
    props: {
        nameFilter: {
            type: String,
            required: true,
        },
        publisherFilter: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            baseURL: getUmbracoEnv(),

            isEdgeBrowser: window.navigator.userAgent.indexOf('Edge') > -1,
        };
    },
    computed: {
        filteredPartners() {
            // Filter by publisher name, then by search string
            return this.$store.state.partners
                .filter(
                    (partner) =>
                        this.publisherFilter === 'All' ||
                        partner.publisher === this.publisherFilter
                )
                .filter((partner) =>
                    partner.name
                        .toLowerCase()
                        .includes(this.nameFilter.toLowerCase())
                );
        },
    },
};
</script>

<style lang="scss" scoped>
.partner-list-section {
    position: relative;
    margin-bottom: 40px;
    .partners-section {
        position: relative;
        margin: 15px 9px 15px 9px;
        .partner-card {
            background-color: transparent;
            border-color: transparent;
            border-radius: 6px;
            &.v-card--hover:hover {
                -webkit-box-shadow: 0 37px 31px -18px rgba(30, 30, 30, 0.5);
                -moz-box-shadow: 0 37px 31px -18px rgba(30, 30, 30, 0.5);
                box-shadow: 0 37px 31px -18px rgba(30, 30, 30, 0.5);
            }
        }

        .partner-name {
            font-weight: bold;
            font-size: 16px;
            letter-spacing: normal;
            margin: 10px 0 6px 0;
        }
        .partner-publisher {
            font-size: 14px;
            letter-spacing: normal;
            font-weight: 500;
            color: #7e7e7e;
            margin: 0;
        }
    }
    .no-results-section {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 80vh;
        .no-results-group {
            font-family: KlavikaNX-Regular, serif;
            font-size: 26px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            min-width: 465px;
            .no-result-image {
                margin: 0 auto 26px auto;
            }
        }
    }
}
@include break('sm') {
    .partners-section {
        margin: 20px 9px 35px 9px;
    }
    .partner-name {
        margin: 10px 0 8px 0;
    }
}
</style>
